// import React, { useState, useEffect } from 'react';
// import { Link } from 'react-router-dom';
// import {
//   Box,
//   Card,
//   CardContent,
//   Typography,
//   Button,
//   IconButton,
//   CircularProgress,
//   Alert,
//   Snackbar,
//   Table,
//   TableBody,
//   TableCell,
//   TableContainer,
//   TableHead,
//   TableRow,
//   Paper,
//   Chip
// } from '@mui/material';
// import { Edit as EditIcon, Delete as DeleteIcon, Add as AddIcon } from '@mui/icons-material';
// import VehicleRouteServices from '../../services/externalServices/trackingservices/vehicleRouteServices';
// import OwnerServices from '../../services/externalServices/trackingservices/ownerServices';

// const VehicleRoutes = () => {
//   const [routes, setRoutes] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [ownerId, setOwnerId] = useState(null);
//   const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'info' });

//   // Get owner ID from localStorage and match with owners API
//   useEffect(() => {
//     const getOwnerIdFromLocalStorage = async () => {
//       try {
//         // Get admin data from localStorage
//         const adminData = localStorage.getItem("admin");

//         if (!adminData) {
//           setSnackbar({
//             open: true,
//             message: "No admin data found in localStorage. Please login again.",
//             severity: "error"
//           });
//           setLoading(false);
//           return;
//         }

//         const admin = JSON.parse(adminData);
//         const adminEmail = admin.email;

//         console.log("Admin email from localStorage:", adminEmail);

//         if (!adminEmail) {
//           setSnackbar({
//             open: true,
//             message: "No email found in admin data.",
//             severity: "error"
//           });
//           setLoading(false);
//           return;
//         }

//         // Get all owners from the API
//         const allOwners = await OwnerServices.getAllOwners();
//         console.log("All owners:", allOwners);

//         if (!allOwners || allOwners.length === 0) {
//           setSnackbar({
//             open: true,
//             message: "No owners found in the system.",
//             severity: "warning"
//           });
//           setLoading(false);
//           return;
//         }

//         // Find matching owner by email
//         const matchingOwner = allOwners.find(owner =>
//           owner.email && owner.email.toLowerCase() === adminEmail.toLowerCase()
//         );

//         if (!matchingOwner) {
//           setSnackbar({
//             open: true,
//             message: `No owner found with email: ${adminEmail}`,
//             severity: "warning"
//           });
//           setLoading(false);
//           return;
//         }

//         console.log("Matching owner found:", matchingOwner);
//         setOwnerId(matchingOwner._id);

//       } catch (error) {
//         console.error('Error getting owner ID from localStorage:', error);
//         setSnackbar({
//           open: true,
//           message: "Error retrieving owner information. Please try again.",
//           severity: "error"
//         });
//         setLoading(false);
//       }
//     };

//     getOwnerIdFromLocalStorage();
//   }, []);

//   // Fetch routes by owner ID when ownerId is available
//   useEffect(() => {
//     const fetchRoutesByOwnerId = async () => {
//       if (!ownerId) return;

//       try {
//         setLoading(true);
//         console.log("Fetching routes for owner ID:", ownerId);

//         // Try to get routes by owner ID first
//         let ownerRoutes = [];

//         try {
//           // Assuming VehicleRouteServices has a method to get routes by owner ID
//           // If this method doesn't exist, we'll fall back to getting all routes and filtering
//           if (VehicleRouteServices.getVehicleRoutesByOwnerId) {
//             ownerRoutes = await VehicleRouteServices.getVehicleRoutesByOwnerId(ownerId);
//           } else {
//             // Fallback: get all routes and filter by owner ID
//             const allRoutes = await VehicleRouteServices.getAllVehicleRoutes();
//             ownerRoutes = allRoutes.filter(route =>
//               route.assigned_owner_id === ownerId || route.ownerId === ownerId
//             );
//           }
//         } catch (error) {
//           console.log("getVehicleRoutesByOwnerId method not available, using fallback");
//           // Fallback: get all routes and filter by owner ID
//           const allRoutes = await VehicleRouteServices.getAllVehicleRoutes();
//           ownerRoutes = allRoutes.filter(route =>
//             route.assigned_owner_id === ownerId || route.ownerId === ownerId
//           );
//         }

//         console.log("Filtered routes for owner:", ownerRoutes);
//         setRoutes(ownerRoutes);

//         if (ownerRoutes.length === 0) {
//           setSnackbar({
//             open: true,
//             message: "No routes found for this owner.",
//             severity: "info"
//           });
//         }

//       } catch (error) {
//         console.error('Error fetching vehicle routes by owner ID:', error);
//         setSnackbar({
//           open: true,
//           message: "Error fetching vehicle routes. Please try again.",
//           severity: "error"
//         });
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchRoutesByOwnerId();
//   }, [ownerId]);

//   const handleDelete = async (id) => {
//     try {
//       // Show confirmation dialog
//       const confirmDelete = window.confirm(
//         "Are you sure you want to delete this route? This action cannot be undone."
//       );

//       if (!confirmDelete) return;

//       await VehicleRouteServices.deleteVehicleRouteById(id);
//       setRoutes(routes.filter(route => route._id !== id));

//       setSnackbar({
//         open: true,
//         message: "Route deleted successfully!",
//         severity: "success"
//       });
//     } catch (error) {
//       console.error('Error deleting vehicle route:', error);
//       setSnackbar({
//         open: true,
//         message: "Error deleting route. Please try again.",
//         severity: "error"
//       });
//     }
//   };

//   const handleCloseSnackbar = () => {
//     setSnackbar({ ...snackbar, open: false });
//   };

//   // Show loading spinner while fetching data
//   if (loading) {
//     return (
//       <Box sx={{
//         maxWidth: 1200,
//         mx: 'auto',
//         p: 3,
//         display: 'flex',
//         justifyContent: 'center',
//         alignItems: 'center',
//         minHeight: '400px'
//       }}>
//         <CircularProgress size={60} />
//         <Typography variant="h6" sx={{ ml: 2 }}>
//           Loading vehicle routes...
//         </Typography>
//       </Box>
//     );
//   }

//   return (
//     <Box sx={{ maxWidth: 1400, mx: 'auto', p: 3 }}>
//       <Card elevation={3}>
//         <CardContent>
//           <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
//             <Typography variant="h4" component="h1" color="primary">
//               Vehicle Routes
//               {ownerId && (
//                 <Typography variant="subtitle1" color="text.secondary" sx={{ mt: 1 }}>
//                   Owner ID: {ownerId}
//                 </Typography>
//               )}
//             </Typography>
//             <Button
//               component={Link}
//               to="/add-vehicle-route"
//               variant="contained"
//               startIcon={<AddIcon />}
//               disabled={!ownerId}
//             >
//               Add Route
//             </Button>
//           </Box>

//           {routes.length === 0 ? (
//             <Box sx={{ textAlign: 'center', py: 4 }}>
//               <Typography variant="h6" color="text.secondary" gutterBottom>
//                 No vehicle routes found
//               </Typography>
//               <Typography variant="body2" color="text.secondary">
//                 {ownerId ?
//                   "No routes are assigned to your account yet." :
//                   "Unable to load routes. Please check your account settings."
//                 }
//               </Typography>
//             </Box>
//           ) : (
//             <TableContainer component={Paper} elevation={1}>
//               <Table sx={{ minWidth: 650 }} aria-label="vehicle routes table">
//                 <TableHead>
//                   <TableRow sx={{ backgroundColor: 'primary.main' }}>
//                     <TableCell sx={{ color: 'white', fontWeight: 'bold' }}>
//                       Route Name
//                     </TableCell>
//                     <TableCell align="center" sx={{ color: 'white', fontWeight: 'bold' }}>
//                       Stops
//                     </TableCell>
//                     {/* <TableCell align="center" sx={{ color: 'white', fontWeight: 'bold' }}>
//                       Segments
//                     </TableCell> */}
//                     <TableCell align="center" sx={{ color: 'white', fontWeight: 'bold' }}>
//                       Route Type
//                     </TableCell>
//                     <TableCell align="center" sx={{ color: 'white', fontWeight: 'bold' }}>
//                       Approval Required
//                     </TableCell>
//                     {/* <TableCell align="center" sx={{ color: 'white', fontWeight: 'bold' }}>
//                       Owner ID
//                     </TableCell> */}
//                     <TableCell align="center" sx={{ color: 'white', fontWeight: 'bold' }}>
//                       Actions
//                     </TableCell>
//                   </TableRow>
//                 </TableHead>
//                 <TableBody>
//                   {routes.map((route, index) => (
//                     <TableRow
//                       key={route._id}
//                       sx={{
//                         '&:nth-of-type(odd)': { backgroundColor: 'action.hover' },
//                         '&:hover': { backgroundColor: 'action.selected' }
//                       }}
//                     >
//                       <TableCell component="th" scope="row">
//                         <Typography variant="subtitle1" fontWeight="medium">
//                           {route.route_name}
//                         </Typography>
//                       </TableCell>
//                       <TableCell align="center">
//                         <Chip
//                           label={route.stops?.length || 0}
//                           size="small"
//                           color="primary"
//                           variant="outlined"
//                         />
//                       </TableCell>
//                       {/* <TableCell align="center">
//                         <Chip
//                           label={route.segments?.length || 0}
//                           size="small"
//                           color="secondary"
//                           variant="outlined"
//                         />
//                       </TableCell> */}
//                       <TableCell align="center">
//                         <Chip
//                           label={route.routeType || 'N/A'}
//                           size="small"
//                           color={route.routeType === 'pickup' ? 'success' : 'info'}
//                           variant="filled"
//                         />
//                       </TableCell>
//                       <TableCell align="center">
//                         <Chip
//                           label={route.approvalNeeded ? 'Yes' : 'No'}
//                           size="small"
//                           color={route.approvalNeeded ? 'warning' : 'success'}
//                           variant="filled"
//                         />
//                       </TableCell>
//                       {/* <TableCell align="center">
//                         <Typography variant="caption" color="text.secondary">
//                           {route.assigned_owner_id ?
//                             `${route.assigned_owner_id.substring(0, 8)}...` :
//                             'N/A'
//                           }
//                         </Typography>
//                       </TableCell> */}
//                       <TableCell align="center">
//                         <Box sx={{ display: 'flex', gap: 1, justifyContent: 'center' }}>
//                           <IconButton
//                             component={Link}
//                             to={`/edit-vehicle-route/${route._id}`}
//                             color="primary"
//                             title="Edit Route"
//                             size="small"
//                           >
//                             <EditIcon />
//                           </IconButton>
//                           <IconButton
//                             onClick={() => handleDelete(route._id)}
//                             color="error"
//                             title="Delete Route"
//                             size="small"
//                           >
//                             <DeleteIcon />
//                           </IconButton>
//                         </Box>
//                       </TableCell>
//                     </TableRow>
//                   ))}
//                 </TableBody>
//               </Table>
//             </TableContainer>
//           )}

//           {/* {routes.length > 0 && (
//             <Box sx={{ mt: 2, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
//               <Typography variant="body2" color="text.secondary">
//                 Total Routes: {routes.length}
//               </Typography>
//               <Typography variant="body2" color="text.secondary">
//                 Total Stops: {routes.reduce((sum, route) => sum + (route.stops?.length || 0), 0)} |
//                 Total Segments: {routes.reduce((sum, route) => sum + (route.segments?.length || 0), 0)}
//               </Typography>
//             </Box>
//           )} */}
//         </CardContent>
//       </Card>

//       {/* Snackbar for notifications */}
//       <Snackbar
//         open={snackbar.open}
//         autoHideDuration={6000}
//         onClose={handleCloseSnackbar}
//         anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
//       >
//         <Alert onClose={handleCloseSnackbar} severity={snackbar.severity}>
//           {snackbar.message}
//         </Alert>
//       </Snackbar>
//     </Box>
//   );
// };

// export default VehicleRoutes;

// src/app/Tracking/vehicle-route/VehicleRoutes.js
// src/app/Tracking/vehicle-route/VehicleRoutes.js
import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import {
  Box,
  Card,
  CardContent,
  Typography,
  Button,
  IconButton,
  CircularProgress,
  Snackbar,
  Alert,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Chip,
} from "@mui/material";
import {
  Edit as EditIcon,
  Delete as DeleteIcon,
  Add as AddIcon,
} from "@mui/icons-material";
import { Visibility as ViewIcon } from "@mui/icons-material";

import VehicleRouteServices from "../../services/externalServices/trackingservices/vehicleRouteServices";
import OwnerServices from "../../services/externalServices/trackingservices/ownerServices";
import {
  getOwnerDetailsFromLocalStorage,
  getOwnerIdFromLocalStorage,
} from "../../utils/auth";

/* ────────── styled helpers ────────── */
const headerCell = {
  color: "common.white",
  fontWeight: "bold",
  borderBottom: "none",
};

const zebra = (theme) => ({
  "&:nth-of-type(odd)": { backgroundColor: theme.palette.action.hover },
  "&:hover": { backgroundColor: theme.palette.action.selected },
});

export default function VehicleRoutes() {
  /* state */
  const [routes, setRoutes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [ownerId, setOwnerId] = useState(null);
  const [snack, setSnack] = useState({ open: false, msg: "", sev: "info" });
  const [isSuperAdmin, setIsSuperAdmin] = useState(false);

  const openSnack = (msg, sev) => setSnack({ open: true, msg, sev });

  /* delete */
  const handleDelete = async (id) => {
    if (!window.confirm("Delete this route?")) return;
    try {
      await VehicleRouteServices.deleteVehicleRouteById(id);
      setRoutes((r) => r.filter((rt) => rt._id !== id));
      openSnack("Route deleted", "success");
    } catch (e) {
      console.error(e);
      openSnack("Delete failed", "error");
    }
  };

  /* fetch owner + routes */
  // useEffect(() => {
  //   (async () => {
  //     try {
  //       const admin = JSON.parse(localStorage.getItem('admin') || '{}');
  //       const owners = await OwnerServices.getAllOwners();
  //       const owner  = owners.find(o => o.email?.toLowerCase() === admin.email?.toLowerCase());
  //       if (!owner) { openSnack('Owner not found', 'error'); setLoading(false); return; }
  //       setOwnerId(owner._id);

  //       const data = VehicleRouteServices.getVehicleRoutesByOwnerId
  //         ? await VehicleRouteServices.getVehicleRoutesByOwnerId(owner._id)
  //         : (await VehicleRouteServices.getAllVehicleRoutes())
  //             .filter(r => r.ownerId === owner._id || r.assigned_owner_id === owner._id);

  //       setRoutes(data);
  //       if (!data.length) openSnack('No routes for this owner', 'info');
  //     } catch (e) {
  //       console.error(e);
  //       openSnack('Failed to load routes', 'error');
  //     } finally { setLoading(false); }
  //   })();
  // }, []);
  useEffect(() => {
    fetchVehicleRoutes();
  }, []);

  const fetchVehicleRoutes = async () => {
    try {
      setLoading(true);
      // setError(null);

      const ownerId = getOwnerIdFromLocalStorage();
      const ownerDetails = getOwnerDetailsFromLocalStorage();
      const role = ownerDetails?.role;

      setIsSuperAdmin(role === "superAdmin");

      setOwnerId(ownerId);
      if (!ownerId) {
        throw new Error("No owner access found. Please login again.");
      }

      const res = await VehicleRouteServices.getVehicleRoutesByOwnerId(ownerId);
      const vehiclerouteData = res?.data?.vehicles || res?.data || res || [];
      setRoutes(vehiclerouteData);
    } catch (e) {
      // setError(e.message || 'Failed to load vehicles');
      console.log("error in getting the vehicle route", e);
    } finally {
      setLoading(false);
    }
  };

  /* loading */
  if (loading) {
    return (
      <Box
        sx={{
          maxWidth: 1200,
          mx: "auto",
          p: 4,
          display: "flex",
          alignItems: "center",
          minHeight: 400,
        }}
      >
        <CircularProgress size={60} />
        <Typography variant="h6" sx={{ ml: 2 }}>
          Loading routes…
        </Typography>
      </Box>
    );
  }

  /* main UI */
  return (
    <Box sx={{ maxWidth: 1400, mx: "auto", p: 3 }}>
      <Card elevation={3} sx={{ borderRadius: 3 }}>
        <CardContent>
          {/* header */}
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              flexWrap: "wrap",
              mb: 3,
            }}
          >
            <Box>
              <Typography variant="h4" fontWeight="bold" color="primary.main">
                Vehicle Routes
              </Typography>
              {ownerId && (
                <Typography variant="caption" color="text.secondary">
                  Owner&nbsp;ID:&nbsp;{ownerId}
                </Typography>
              )}
            </Box>

            {isSuperAdmin && (
              <Button
                component={Link}
                to="/add-vehicle-route"
                variant="contained"
                startIcon={<AddIcon />}
                sx={{ mt: { xs: 2, sm: 0 } }}
              >
                Add Route
              </Button>
            )}
          </Box>

          {/* table or empty */}
          {routes.length === 0 ? (
            <Box sx={{ textAlign: "center", py: 6 }}>
              <Typography variant="h6">No routes found</Typography>
              <Typography variant="body2" color="text.secondary">
                {ownerId
                  ? "This owner has no routes yet."
                  : "Owner not identified."}
              </Typography>
            </Box>
          ) : (
            <TableContainer component={Paper} variant="outlined">
              <Table size="small">
                <TableHead>
                  <TableRow sx={{ bgcolor: "primary.main" }}>
                    <TableCell sx={headerCell}>Route Name</TableCell>
                    <TableCell align="center" sx={headerCell}>
                      Stops
                    </TableCell>
                    <TableCell align="center" sx={headerCell}>
                      Route Type
                    </TableCell>
                    <TableCell align="center" sx={headerCell}>
                      Approval
                    </TableCell>
                    <TableCell align="center" sx={headerCell}>
                      Actions
                    </TableCell>
                  </TableRow>
                </TableHead>

                <TableBody>
                  {routes.map((r) => (
                    <TableRow key={r._id} sx={zebra}>
                      <TableCell>{r.route_name}</TableCell>

                      <TableCell align="center">
                        <Chip
                          label={r.stops?.length || 0}
                          size="small"
                          color="primary"
                          variant="outlined"
                        />
                      </TableCell>

                      <TableCell align="center">
                        <Chip
                          label={r.routeType || "N/A"}
                          size="small"
                          color={r.routeType === "pickup" ? "success" : "info"}
                        />
                      </TableCell>

                      <TableCell align="center">
                        <Chip
                          label={r.approvalNeeded ? "Yes" : "No"}
                          size="small"
                          color={r.approvalNeeded ? "warning" : "success"}
                        />
                      </TableCell>

                      <TableCell align="center">
                        {isSuperAdmin ? (
                          <>
                            {/* Edit */}
                            <IconButton
                              component={Link}
                              to={`/edit-vehicle-route/${r._id}`}
                              size="small"
                              color="primary"
                              title="Edit"
                            >
                              <EditIcon fontSize="small" />
                            </IconButton>

                            {/* Delete */}
                            <IconButton
                              onClick={() => handleDelete(r._id)}
                              size="small"
                              color="error"
                              title="Delete"
                            >
                              <DeleteIcon fontSize="small" />
                            </IconButton>
                          </>
                        ) : (
                          /* View only */
                          <IconButton
                            component={Link}
                            to={`/edit-vehicle-route/${r._id}`}
                            size="small"
                            color="info"
                            title="View"
                          >
                            <ViewIcon fontSize="small" />
                          </IconButton>
                        )}
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          )}
        </CardContent>
      </Card>

      {/* snackbar */}
      <Snackbar
        open={snack.open}
        autoHideDuration={6000}
        onClose={() => setSnack({ ...snack, open: false })}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
      >
        <Alert
          variant="filled"
          severity={snack.sev}
          onClose={() => setSnack({ ...snack, open: false })}
        >
          {snack.msg}
        </Alert>
      </Snackbar>
    </Box>
  );
}
